
import React from 'react'
import {Link} from 'react-static'
import ForgotPasswordForm from '../components/ForgotPasswordForm'

export default () => (
  <div>
    <div className="text-center m-b-20">
      <Link to="/" className="logo-lg">
        <img src="logo_light_32.png" alt="logo"/>{' '}
        <span>ColorRibbon</span>
      </Link>
    </div>

    <ForgotPasswordForm />
  </div>
)



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/containers/ForgotPassword.js